import { useEffect, useState } from 'react';

// Countdown runs from 00:17:34 and restarts automatically when it reaches zero.
const DURATION_MS = (17 * 60 + 34) * 1000;
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = (now - START) % DURATION_MS;
  const remaining = Math.ceil((DURATION_MS - elapsed) / 1000) % (DURATION_MS / 1000 + 1);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

function pad(n: number) {
  return n.toString().padStart(2, '0');
}
